// Campus photo for /colleges/university-of-cincinnati: Public domain, by Bike756, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_Cincinnati_Main_Campus_2008.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-cincinnati/; credited under the photo.
const photo = {
    "slug": "university-of-cincinnati",
    "alt": "Fifth Third Arena and surrounding buildings on the main campus of the University of Cincinnati in Cincinnati, Ohio",
    "src": "/colleges/university-of-cincinnati/campus-1600.webp",
    "srcSmall": "/colleges/university-of-cincinnati/campus-800.webp",
    "srcMid": "/colleges/university-of-cincinnati/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-cincinnati/og.jpg",
    "title": "University of Cincinnati Main Campus 2008",
    "author": "Bike756",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_Cincinnati_Main_Campus_2008.JPG",
    "read": "2026-10-01"
};

export default photo;
